import addMonths from 'date-fns/addMonths';
import isBefore from 'date-fns/isBefore';

import { MONTHS_BEFORE_EXPIRE_CARD_WARNING } from '@/shared/config';

class PaidPreparer {
  contactName = '';

  businessName = '';

  businessPhone = '';

  email = '';

  ein = '';

  efin = '';

  etin = '';

  ptin = '';

  addressType = '';

  line1 = '';

  line2 = '';

  city = '';

  stateOrProvince = '';

  postalCode = '';

  unitCost = 0;

  country = '';

  isActive = 1;

  isReady = false;

  billingFirstName = '';

  billingLastName = '';

  billingStreet = '';

  billingCity = '';

  billingState = '';

  billingZip = '';

  billingCountry = '';

  cardNumber = '';

  expirationDate = '';

  cardType = '';

  userId = '';

  billingStatus = '';

  billingStatusId = '';

  currentBillableTR = 0;

  lifetimeBillableTR = 0;

  totalAmtDue = 0;

  cardStatus = '';

  totalAmtPastDue = 0;

  adjustmentType = '';

  adjustmentAmount = 0;

  adjustmentNote = '';

  accountType = '';

  updateCustDataFromRaw(rawData) {
    // console.log(rawData);
    this.contactName = rawData.PaidPreparer.ContactName;
    this.businessName = rawData.PaidPreparer.BusinessName;
    this.businessPhone = rawData.PaidPreparer.BusinessPhone;
    this.email = rawData.PaidPreparer.Email;
    this.ein = rawData.PaidPreparer.EIN;
    this.efin = rawData.PaidPreparer.EFIN;
    this.etin = rawData.PaidPreparer.ETIN;
    this.ptin = rawData.PaidPreparer.PTIN;
    this.addressType = rawData.PaidPreparer.AddressType;
    this.line1 = rawData.PaidPreparer.Line1;
    this.line2 = rawData.PaidPreparer.Line2;
    this.city = rawData.PaidPreparer.City;
    this.stateOrProvince = rawData.PaidPreparer.StateOrProvince;
    this.postalCode = rawData.PaidPreparer.PostalCode;
    this.unitCost = rawData.PaidPreparer.UnitCost;
    this.country = rawData.PaidPreparer.Country;
    this.isActive = rawData.PaidPreparer.Active === 1;
    this.isReady = true;
    this.adjustmentType = rawData.PaidPreparer.AdjustmentType;
    this.adjustmentAmount = rawData.PaidPreparer.AdjustmentAmount;
    this.adjustmentNote = rawData.PaidPreparer.AdjustmentNote;
    this.billingStatus = rawData.PaidPreparer.BillingStatus;
    this.billingStatusId = rawData.PaidPreparer.BillingStatusID;
    this.accountType = rawData.PaidPreparer.AccountType;
  }

  updateAdnDataFromRaw(rawData) {
    if (rawData && rawData.billAddress) {
      this.billingFirstName = rawData.billAddress.firstName;
      this.billingLastName = rawData.billAddress.lastName;
      this.billingStreet = rawData.billAddress.address;
      this.billingCity = rawData.billAddress.city;
      this.billingState = rawData.billAddress.state;
      this.billingZip = rawData.billAddress.zip;
      this.billingCountry = rawData.billAddress.country;
    } else {
      this.billingFirstName = '';
      this.billingLastName = '';
      this.billingStreet = '';
      this.billingCity = '';
      this.billingState = '';
      this.billingZip = '';
      this.billingCountry = '';
    }
    if (rawData && rawData.paymentMethod && rawData.paymentMethod.creditCard) {
      this.cardNumber = rawData.paymentMethod.creditCard.cardNumber;
      this.expirationDate = rawData.paymentMethod.creditCard.expirationDate;
      this.cardType = rawData.paymentMethod.creditCard.cardType;
    } else {
      this.cardNumber = '';
      this.cardType = '';
    }
  }

  deriveCreditCardStatus() {
    if (!this.expirationDate || this.expirationDate.length < 7) {
      return '';
    }
    const parts = this.expirationDate.split('-');
    const expMM = parts[1];
    const expYY = parts[0];

    const today = new Date();
    const todayMM = today.getMonth() + 1;
    const todayYY = today.getFullYear();

    const cutoffDate = addMonths(today, MONTHS_BEFORE_EXPIRE_CARD_WARNING);
    const cutoffMM = cutoffDate.getMonth() + 1;
    const cutoffYY = cutoffDate.getFullYear();

    // We need to default 'today' to be first of the month since cards don't
    // store a day of the month for expiration
    const currentAsDate = new Date(todayYY, todayMM, 1);
    const cutoffAsDate = new Date(cutoffYY, cutoffMM, 1);
    const expAsDate = new Date(expYY, expMM, 1);

    if (isBefore(expAsDate, currentAsDate)) {
      return 'Expired';
    }

    if (isBefore(expAsDate, cutoffAsDate)) {
      return 'Expiring Soon';
    }
    return '';
  }
}

export default new PaidPreparer();
